import { ErrorBoundary } from "../../../components/ErrorBoundary.js";
import { FormBuilderDisplayRenderer } from "../../FormBuilder/components/FormBuilderDisplayRenderer/index.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Reports/shared/ReportEntryFieldsDisplayRenderer.tsx
var ReportEntryFieldsDisplayRenderer = ({ formId, valuesByFieldId }) => {
	return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(FormBuilderDisplayRenderer, {
		formId,
		valuesByFieldId: valuesByFieldId || {}
	}) });
};
//#endregion
export { ReportEntryFieldsDisplayRenderer };

//# sourceMappingURL=ReportEntryFieldsDisplayRenderer.js.map